export enum CompanyImporterEnum {
  ellos = 'ELLOS',
  external = 'EXTERNAL'
}
